import { RootState, useSelector } from 'redux/store';
import { useTheme } from '@mui/material/styles';
import createAvatar from '../utils/createAvatar';
import Avatar, { Props as AvatarProps } from './Avatar';
import { CustomTheme } from 'enums/customeTheme';

export default function MyAvatar({ user, ...other }: AvatarProps & { user?: any }) {
  const theme = useTheme();
  const customTheme = useSelector((state: RootState) => state.customer?.customer?.customTheme);
  return (
    <Avatar
      src={user?.photoURL}
      alt={user?.name}
      customColor={
        customTheme === CustomTheme.Sage
          ? theme.palette.sage_green
          : user?.photoURL
            ? 'default'
            : createAvatar(user?.name).customColor
      }
      {...other}
      sx={customTheme === CustomTheme.Sage ? { color: theme.palette.common.white } : undefined}
    >
      {createAvatar(user?.name).name}
    </Avatar>
  );
}
